import { render, staticRenderFns } from "./UjianFinish.vue?vue&type=template&id=5e7f7a37&scoped=true"
import script from "./UjianFinish.vue?vue&type=script&lang=js"
export * from "./UjianFinish.vue?vue&type=script&lang=js"
import style0 from "./UjianFinish.vue?vue&type=style&index=0&id=5e7f7a37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f7a37",
  null
  
)

export default component.exports